import { Box } from "@mui/system";
import { capitalize } from "lodash";

export default function UserInviteStatus({ inviteStatus }) {
    const status = inviteStatus?.toLowerCase();
    const colors = STATUS_COLORS[status] || {
        color: "#000",
        backgroundColor: "#f0f0f0",
    };

    return (
        <Box sx={{...styles.chip, color: colors.color, backgroundColor: colors.backgroundColor}}>
            {capitalize(status)}
        </Box>
    );
}

const STATUS_COLORS = {
    pending: {
        color: "#bd6500",
        backgroundColor: "#faf0d1",
    },
    accepted: {
        color: "#245b26",
        backgroundColor: "#d4edda",
    },
    expired: {
        color: "#373e44",
        backgroundColor: "#e2e3e5",
    },
    revoked: {
        color: "#b9392d",
        backgroundColor: "#ffe5e5",
    },
};

const styles = {
    chip: {
        fontSize: "14px",
        width: "fit-content",
        borderRadius: "15px",
        padding: "4px 12px",
    }
}